import { colorPalette } from "@command-center-app/utils/colorPalette";
import { ucwords } from "@command-center-app/utils";
import { primaryContactDetails } from "@command-center-app/utils/common.util";
import { mapVendorAddressToFormValues } from "@command-center-app/utils/vendorAddress";
import {
  BannerSection,
  ICollectionList,
  IProductList,
  IServiceList,
  IServiceListApiResponse,
} from "..";
import { IContactInfo } from "@command-center-app/index";

function createData(data: Record<string, any>) {
  return { ...data };
}
export const columnNames = [
  "serviceType",
  "service",
  "status",
  "vendor",
  "brand",
  "stock",
  "price",
  "lastActivity",
  "action",
];

export const getProductHeadCells = (
  showVendor: boolean,
  source: string = "",
) => {
  const headCells = [
    {
      id: "product",
      type: "string",
      numeric: false,
      disablePadding: true,
      label: "Product",
      source,
    },
    {
      id: "status",
      type: "string",
      numeric: false,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "vendor",
      type: "array",
      numeric: false,
      disablePadding: false,
      label: "Vendor",
    },
    {
      id: "brand",
      type: "string",
      numeric: true,
      disablePadding: false,
      label: "Brand",
      centerAlign: true,
    },
    {
      id: "stock",
      type: "number",
      numeric: true,
      disablePadding: false,
      label: "Stock",
      centerAlign: true,
    },
    {
      id: "price",
      type: "number",
      numeric: true,
      disablePadding: false,
      label: "Price",
      tooltip: true,
      tooltipMsg: "The base price for one unit for an order of 100 units",
      sortIconRight: true,
      centerAlign: true,
    },
    {
      id: "lastActivity",
      type: "date",
      numeric: true,
      disablePadding: false,
      label: "Last Activity",
      sortIconRight: true,
      centerAlign: true,
    },
    {
      id: "action",
      label: "",
      numeric: true,
      disablePadding: false,
    },
  ];

  return showVendor
    ? headCells
    : headCells.filter((cell) => cell.id !== "vendor");
};

export const allFamilies = [
  { label: "Accessories", value: "accessories" },
  { label: "Apparel", value: "apparel" },
  { label: "Backpacks", value: "backpacks" },
  { label: "Bags", value: "bags" },
  { label: "Bonus items", value: "bonus-items" },
  { label: "Coffee mugs", value: "coffee-mugs" },
  { label: "Drinkware", value: "drinkware" },
  { label: "Electronics", value: "electronics" },
  { label: "Food & Beverage", value: "food-&-beverage" },
  { label: "Hats & Socks", value: "hats-&-socks" },
  { label: "Home & DIY", value: "home-&-diy" },
  { label: "Home & Games", value: "home-&-games" },
  { label: "Notebooks & pens", value: "notebooks-&-pens" },
  { label: "Office", value: "office" },
  { label: "Outerwear", value: "outerwear" },
  { label: "Packaging ", value: "packaging" },
  { label: "Signs & Displays", value: "signs-&-displays" },
  { label: "Sweatshirts ", value: "sweatshirts" },
  { label: "Tech items", value: "tech-items" },
  { label: "Tops", value: "tops" },
  { label: "Totes & Bags", value: "totes-&-bags" },
  { label: "Travel tumblers", value: "travel-tumblers" },
  { label: "Water bottles", value: "water-bottles" },
];

export const leftProductSectionDetails = [
  {
    label: "Product Status",
    name: "productStatus",
    type: "select",
    value: "Published",
    options: [
      { label: "Draft", value: "draft" },
      { label: "Published", value: "published" },
    ],
    disabled: true,
  },
  {
    label: "Inventory Status",
    name: "inventoryStatus",
    type: "select",
    value: "In Stock",
    options: [
      { label: "In Stock", value: "in stock" },
      { label: "Out of Stock", value: "out of stock" },
    ],
    disabled: true,
  },
  {
    label: "Supplier Inventory URL",
    name: "supplierUrl",
    type: "text",
    value: "supplier.com",
    disabled: true,
  },
  {
    label: "Product Thumbnail",
    name: "thumbnail",
    type: "image",
    value: "",
    disabled: true,
  },
  {
    label: "Created By",
    name: "createdBy",
    type: "text",
    value: "Rob Bowman",
    disabled: true,
  },
];

export const serviceListing = [
  createData({
    id: 0,
    service: "Screen Printing",
    status: "Active",
    vendor: { id: "vendor", name: "SanMar" },
    serviceType: "Decoration",
    lastActivity: "2024-12-20",
    action: true,
  }),
  createData({
    id: 4,
    service: "Screen Printing",
    status: "Active",
    vendor: { id: "vendor", name: "SanMar" },
    serviceType: "Decoration",
    lastActivity: "2024-12-20",
    action: true,
  }),
  createData({
    id: 1,
    service: "Screen Printing",
    status: "Active",
    vendor: { id: "vendor", name: "SanMar" },
    serviceType: "Decoration",
    lastActivity: "2024-12-20",
    action: true,
  }),
  createData({
    id: 2,
    service: "Screen Printing",
    status: "Active",
    vendor: { id: "vendor", name: "SanMar" },
    serviceType: "Decoration",
    lastActivity: "2024-12-20",
    action: true,
  }),
  createData({
    id: 3,
    service: "Screen Printing",
    status: "Active",
    vendor: { id: "vendor", name: "SanMar" },
    serviceType: "Decoration",
    lastActivity: "2024-12-20",
    action: true,
  }),
];

export const serviceHeadCells: any = [
  {
    id: "service",
    type: "string",
    numeric: false,
    disablePadding: true,
    label: "Service",
  },
  {
    id: "status",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "vendor",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Vendor",
  },
  {
    id: "tags",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Service Category Tags",
  },

  {
    id: "lastActivity",
    type: "date",
    numeric: false,
    disablePadding: false,
    label: "Last Activity",
  },
  {
    id: "action",
    label: "",
    numeric: true,
    disablePadding: false,
  },
];

export const generalSectionAccordionData: any = [
  {
    title: "DETAILS",
    content:
      "Detailed information about the product, including specifications and features.",
  },
  {
    title: "TAXONOMY",
    content:
      "Classification and categorization of the product within the system.",
  },
  {
    title: "PRODUCT FEATURES",
    content: "Key features and functionalities offered by the product.",
  },
  {
    title: "ATTRIBUTES",
    content:
      "Various attributes associated with the product, such as color, size, material.",
  },
  {
    title: "PRODUCTION DETAILS",
    content:
      "Information regarding the manufacturing process and origin of the product.",
  },
  {
    title: "HAZMAT",
    content:
      "Hazardous materials information, if applicable, for safe handling and transportation.",
  },
];

export const mockImages = [
  { url: "/assets/images/no-image.png", isDefault: true, id: 0 },
  { url: "/assets/images/no-image.png", isDefault: false, id: 1 },
  { url: "/assets/images/no-image.png", isDefault: false, id: 2 },
  { url: "/assets/images/no-image.png", isDefault: false, id: 3 },
];

export const vendorHeadCells: any = [
  {
    id: "vendor",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "status",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "type",
    type: "string",
    numeric: true,
    disablePadding: false,
    label: "Type",
    centerAlign: true,
  },
  {
    id: "owner",
    type: "string",
    numeric: true,
    disablePadding: false,
    label: "Owner",
    centerAlign: true,
  },
  {
    id: "lastActivity",
    type: "date",
    numeric: true,
    disablePadding: false,
    label: "Last Activity",
  },
  {
    id: "action",
    label: "",
    numeric: true,
    disablePadding: false,
  },
];

export const transformVendors = (data: any) => {
  const vendors = data?.vendorList?.vendors || [];

  return vendors.map((vendor: any) => {
    const {
      _id,
      name,
      status,
      type,
      owner,
      updatedAt,
      vendorCode,
      description,
      minimumOrderQuantity,
    } = vendor;
    const _contactInfo: IContactInfo | any = primaryContactDetails(
      vendor?.profile?.contact || [],
    );
    return createData({
      id: _id,
      vendorId: vendorCode,
      status: status.charAt(0).toUpperCase() + status.slice(1),
      vendor: { id: _id, name, type: "vendor" },
      type: type
        ?.map((t: string) => ucwords(t))
        ?.join(", ")
        ?.toLowerCase(),
      owner: owner ? `${owner.firstName} ${owner.lastName}` : "N/A",
      lastActivity: new Date(updatedAt).toISOString().split("T")[0],
      name: name,
      description: description || "",
      website: vendor?.profile?.company?.website || "",
      phone: _contactInfo?.phone || "",
      contactEmail: _contactInfo?.email || "",
      ...mapVendorAddressToFormValues(vendor?.profile?.company?.addresses),
      minimumOrderQty: minimumOrderQuantity,
      standardProductionTurnAround: vendor?.standardProductionTurnAround || "",
      rushProductionTurnAround: vendor?.rushProductionTurnAround || "",
      rushProduction: vendor?.rushProduction ?? false,
      standardDecorationTurnAround: vendor?.standardDecorationTurnAround || "",
      rushDecorationTurnAround: vendor?.rushDecorationTurnAround || "",
      action: true,
      bdaSupplierNumber: vendor?.profile?.company?.bdaSupplierNumber || "",
      supplierSiteName: vendor?.profile?.company?.supplierSiteName || "",
      supplierSiteId: vendor?.profile?.company?.supplierSiteId || "",
    });
  });
};

export const transformVendorOfferings = (
  data: any,
  type: string = "product",
) => {
  let products: IProductList[] = [];
  switch (type) {
    case "product":
      products = data?.productList?.products ?? [];
      break;
    case "catalog":
      products = data?.distributorCatalogItems?.products ?? [];
      break;
    case "collection-product":
      products = data?.distributorCatalogItems?.products ?? [];
      break;
    case "non-exsiting-product":
      products = data?.nonExistingVendorOfferingsForCatalogs?.products ?? [];
      break;
    default:
      console.warn(`Unknown type passed to transformVendorOfferings: ${type}`);
      break;
  }
  return products.map((product: IProductList) => {
    const {
      _id,
      productCode,
      name: text,
      status,
      availableStock,
      brand,
      color,
      price,
      thumbnail: image,
      vendor,
      updatedAt,
      sequence,
    } = product;

    return createData({
      id: _id,
      productCode: productCode || "",
      sequence: sequence ?? null,
      product:
        type === "product" ||
        type === "catalog" ||
        type === "collection-product"
          ? {
              id: _id,
              text,
              image,
              color: {
                colorName: color?.standardColorName || "",
                colorCode: color?.hex || "#fff",
              },
            }
          : {
              id: _id,
              text,
              image,
            },
      status: ucwords(status),
      vendor: { id: vendor?._id, name: vendor?.name },
      brand,
      stock: availableStock || 0,
      price: price || 0.0,
      lastActivity: new Date(updatedAt).toDateString(),
      action: true,
    });
  });
};

export const transformCollections = (
  data: any,
  type: string = "collection",
) => {
  let products: ICollectionList[] = [];
  switch (type) {
    case "collection":
      products = data?.collectionList?.collections ?? [];
      break;
    default:
      console.warn(`Unknown type passed to transformVendorOfferings: ${type}`);
      break;
  }
  return products.map((product: ICollectionList) => {
    const {
      _id,
      name: text,
      status,
      products,
      owner = "",
      updatedAt,
      sequence,
    } = product;
    return createData({
      id: _id,
      collectionName: text,
      status: ucwords(status),
      quantity: products.length.toString(),
      owner: owner,
      lastActivity: new Date(updatedAt).toLocaleDateString(),
      sequence,
      action: true,
    });
  });
};

export const transformVendorServices = (data: IServiceListApiResponse) => {
  const services = data?.serviceList?.services || [];

  return services.map((service: IServiceList) => {
    const { _id: id, name, status, vendor, tags, updatedAt } = service;

    const timeStamp =
      updatedAt !== "" && updatedAt !== null
        ? new Date(Number(updatedAt)).toString()
        : "";
    const maxVisibleTags = 3;

    const normalizedTags =
      Array.isArray(tags) && tags.length > 0
        ? (() => {
            const visibleTags = tags.slice(0, maxVisibleTags);
            const extraCount = tags.length - maxVisibleTags;

            const renderedTags = visibleTags.map((t: any, index: number) => (
              <div
                key={index}
                style={{
                  background: colorPalette.colorVeryLightGray,
                  padding: "4px 10px",
                  display: "inline-block",
                  marginRight: "8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                {t.value}
              </div>
            ));

            if (extraCount > 0) {
              renderedTags.push(
                <div
                  key="extra"
                  style={{
                    color: colorPalette.colorAccent,
                    display: "inline-block",
                    marginRight: "8px",
                    fontSize: "12px",
                  }}
                >
                  +{extraCount}
                </div>,
              );
            }

            return renderedTags;
          })()
        : "";
    return createData({
      id,
      service: name,
      status: ucwords(status),
      vendor: { id: vendor?._id, name: vendor?.name },
      tags: normalizedTags,
      lastActivity: timeStamp || "",
      action: true,
    });
  });
};

export const productDetails = {
  title: "Fine Jersey Tee",
  sku: "XXXXX",
  productCode: "XXXX",
  dateCreated: "01/01/2025 10:00 PM",
  createdBy: "Rob Bowman",
};

export const vendorDetails = {
  title: "San Mar",
  vendorId: "XXXXX",
  dateCreated: "01/01/2025 10:00 PM",
};

export const serviceDetails = {
  title: "San Mar",
  vendorId: "XXXXX",
  dateCreated: "XX/XX/XXXX XX:XX PM",
};

export const leftServiceSectionDetails = [
  {
    label: "Status",
    name: "Status",
    type: "select",
    value: "Active",
    options: [
      { label: "Active", value: "Active" },
      { label: "In Active", value: "In Active" },
    ],
    disabled: true,
  },
  {
    label: "Service Type",
    name: "serviceType",
    type: "text",
    value: "Decoration",
    disabled: true,
  },
  {
    label: "Created By",
    name: "createdBy",
    type: "text",
    value: "Rob Bowman",
    disabled: true,
  },
];

export const generalProductDetails = [
  {
    details: {
      left: [
        {
          name: "name",
          label: "Product name *",
          placeholder: "Product name",
          component: "text",
        },
        {
          name: "brand",
          label: "Brand",
          placeholder: "Brand",
          component: "text",
        },
        {
          name: "taxJar",
          label: "Tax jar category",
          placeholder: "Tax jar category",
          component: "text",
        },
      ],
      right: [
        {
          name: "description",
          label: "Product description",
          placeholder: "Product description",
          component: "text",
          multiLine: true,
          rows: 4,
        },
        {
          name: "material",
          label: "Product material",
          placeholder: "Product material",
          component: "text",
        },
      ],
    },
    taxonomy: {
      left: [
        {
          name: "productCategory",
          label: "Product category *",
          placeholder: "Product category",
          component: "select",
          options: [],
        },
        {
          name: "productSubCategory",
          label: "Product sub category 1",
          component: "select",
          options: [],
        },
        {
          name: "productSubCategory2",
          label: "Product sub category 2",
          component: "select",
          options: [],
        },
        {
          name: "productTags",
          label: "Product tags",
          component: "autoComplete",
          options: [],
        },
      ],
      right: [
        {
          name: "family",
          label: "Family",
          placeholder: "Select family",
          component: "select",
          options: allFamilies,
        },
        {
          name: "style",
          label: "Style",
          placeholder: "Style",
          component: "text",
        },
      ],
    },
    productfeatures: {
      left: [
        {
          name: "ecoFriendly",
          label: "Eco friendly",
          component: "checkbox",
        },
      ],
      right: [
        {
          name: "recyclable",
          label: "Recyclable",
          component: "checkbox",
        },
      ],
    },
    attributes: {
      left: [
        {
          name: "upc",
          label: "UPC",
          placeholder: "UPC",
          component: "text",
        },
        {
          name: "gtin",
          label: "GTIN",
          placeholder: "GTIN",
          component: "text",
        },
      ],
      right: [
        {
          name: "cautionComment",
          label: "Caution notes",
          placeholder: "Caution notes",
          component: "text",
          multiLine: true,
          rows: 4,
        },
      ],
    },
    productionDetails: {
      left: [
        {
          name: "rushProduction",
          label: "Rush production",
          component: "checkbox",
        },
      ],
      right: [
        {
          name: "minimumOrderQuantity",
          label: "Minimum order quantity *",
          placeholder: "Minimum order quantity",
          component: "text",
        },
      ],
    },
    shipsFrom: {
      left: [
        {
          name: "country",
          label: "Country",
          component: "select",
          options: [],
        },
        {
          name: "city",
          label: "City",
          component: "select",
          options: [],
        },

        {
          name: "availableFrom",
          label: "Available from",
          component: "calendar",
        },
        {
          name: "availableUpto",
          label: "Available up to",
          component: "calendar",
        },
      ],
      right: [
        {
          name: "state",
          label: "State",
          component: "select",
          options: [],
        },
        {
          name: "zipcode",
          label: "Zipcode",
          placeholder: "Zipcode",
          component: "text",
        },
        {
          name: "standardProductionTurnaround",
          label: "Standard production turnaround",
          placeholder: "Standard production turnaround",
          component: "text",
        },
        {
          name: "rushProductionTurnaround",
          label: "Rush production turnaround",
          placeholder: "Rush production turnaround",
          component: "text",
        },
      ],
    },
    hazmat: {
      left: [
        {
          name: "hazmat",
          label: "Hazardous Materials",
          component: "checkbox",
        },
        {
          name: "wattHourRating",
          label: "Watt-hour rating (Wh)",
          placeholder: "Watt-hour rating (Wh)",
          component: "text",
        },
        {
          name: "batteryWeight",
          label: "Battery weight (kg)",
          placeholder: "Battery weight (kg)",
          component: "text",
        },
      ],
      right: [
        {
          name: "hazmatClassification",
          label: "Hazmat classification",
          component: "select",
          options: [
            {
              label: "Lithium-ion batteries contained in equipment",
              value: "Lithium-ion batteries contained in equipment",
            },
            { label: "Lithium-ion batteries", value: "Lithium-ion batteries" },
            {
              label: "Lithium-ion batteries packed with equipment",
              value: "Lithium-ion batteries packed with equipment",
            },
            { label: "Flammable liquids", value: "Flammable liquids" },
            {
              label: "Lithium-ion cell contained in equipment",
              value: "Lithium-ion cell contained in equipment",
            },
            { label: "Lithium-ion cell", value: "Lithium-ion cell" },
            {
              label: "Lithium-ion cell packed with equipment",
              value: "Lithium-ion cell packed with equipment",
            },
          ],
        },
        {
          name: "ethylAlcoholContent",
          label: "Ethyl alcohol content %",
          placeholder: "Ethyl alcohol content %",
          component: "text",
        },
        {
          name: "hazmatVolume",
          label: "Hazmat volume (L)",
          placeholder: "Hazmat volume (L)",
          component: "text",
        },
      ],
    },
    logisticsAndCustoms: {
      left: [
        {
          name: "canBeExported",
          label: "Can ship international",
          component: "checkbox",
        },
        {
          name: "productNameLogistics",
          label: "Customs Product Name *",
          placeholder: "Product name",
          component: "text",
        },
        {
          name: "productValueLogistics",
          label: "Product value",
          placeholder: "Product value",
          component: "text",
          type: "number",
        },
        {
          name: "shippingInsuranceValueLogistics",
          label: "Shipping insurance value",
          placeholder: "Shipping insurance value",
          component: "text",
        },
      ],
      right: [
        {
          name: "productDescriptionLogistics",
          label: "Customs Product Description *",
          placeholder: "Product description",
          component: "text",
          multiLine: true,
          rows: 4,
          inputProps: { maxLength: 250 },
        },
        {
          name: "productCountryOfOrigin",
          label: "Country of origin *",
          component: "select",
          options: [],
        },
        {
          name: "productTariffLogistics",
          label: "Product tariff",
          placeholder: "Product tariff",
          component: "text",
        },
      ],
    },
  },
];

export const productDetailMappings: Record<
  string,
  (value: any) => Record<string, any>
> = {
  taxJar: (value) => ({
    taxJar: value?.name || "",
  }),
  taxonomy: (value: any) => {
    const firstCategory = Array.isArray(value?.categories)
      ? value.categories[0]
      : null;

    const firstCategorySubCategories = firstCategory?.subCategories;

    const productCategory = firstCategory
      ? {
          name: firstCategory.name,
          subCategories: firstCategorySubCategories || [],
        }
      : "";

    const firstSubCategory = Array.isArray(firstCategorySubCategories)
      ? firstCategorySubCategories[0]
      : null;

    const productSubCategory = firstSubCategory
      ? typeof firstSubCategory === "object"
        ? firstSubCategory.name || ""
        : firstSubCategory
      : "";

    const productSubCategory2 =
      firstSubCategory &&
      typeof firstSubCategory === "object" &&
      Array.isArray(firstSubCategory.subCategories2)
        ? firstSubCategory.subCategories2[0] || ""
        : "";

    return {
      categories: Array.isArray(value?.categories)
        ? value.categories.map((cat: any) => ({
            name: typeof cat.name === "string" ? cat.name : "",
            subCategories: Array.isArray(cat.subCategories)
              ? cat.subCategories.map((sc: any) =>
                  typeof sc === "object" && sc !== null
                    ? {
                        name: sc.name || "",
                        subCategories2: sc.subCategories2 || [],
                      }
                    : { name: String(sc), subCategories2: [] },
                )
              : [],
          }))
        : [],
      family: value.family?.slug || "",
      style: typeof value?.style === "string" ? value.style : "",
      productCategory,
      productSubCategory,
      productSubCategory2,
    };
  },

  tags: (tagsArray: any[]) => {
    const tag =
      Array.isArray(tagsArray) && tagsArray.length > 0 ? tagsArray[0] : null;

    return {
      productTags: {
        value: tag?.value || "",
        slug: tag?.value || "",
      },
    };
  },
  productFeatures: (value) => ({
    ecoFriendly: value?.ecoFriendly ?? false,
    recyclable: value?.recyclable ?? false,
  }),
  productDetails: (value) => ({
    upc: value?.upc || "",
    gtin: value?.gtin || "",
    cautionComment: value?.cautionComment || "",
  }),
  shipsFrom: (value) => {
    const ship = value?.[0] || {};
    return {
      country: ship.country || "",
      state: ship.state || "",
      city: ship.city || "",
      zipcode: ship.zipcode || "",
    };
  },
  standardProductionTurnAround: (value) => ({
    standardProductionTurnaround: value ?? "",
  }),
  rushProductionTurnAround: (value) => ({
    rushProductionTurnaround: value ?? "",
  }),
  hazmatDetails: (value) => ({
    hazmat: value?.isHazmat ?? false,
    hazmatClassification: value?.classification ?? "",
    batteryWeight: value?.lithiumIonBatteryDetails?.batteryWeight?.value ?? "",
    wattHourRating: value?.lithiumIonBatteryDetails?.wattHourRating ?? "",
    hazmatVolume: value?.flammableLiquidDetails?.hazmatVolume?.value ?? "",
    ethylAlcoholContent:
      value?.flammableLiquidDetails?.ethylAlcoholContent ?? "",
  }),
  customs: (value) => ({
    productNameLogistics: value?.productFileName || "",
    productValueLogistics: value?.productValue || "",
    productDescriptionLogistics: value?.productDescription || "",
    productTariffLogistics: value?.productTariff || "",
    productCountryOfOrigin: value?.productOriginCountry || "",
  }),
  shippingInsurance: (value) => ({
    shippingInsuranceValueLogistics: value?.value ?? "",
  }),
  rushProduction: (value) => ({
    rushProduction: value ?? false,
  }),
};

export const dimensionProductDetails = [
  {
    name: "quantity",
    label: "Quantity",
    placeholder: "Number of units",
    component: "text",
    type: "number",
  },
  {
    name: "dimensionUnitOfMeasure",
    label: "Dimension unit of measure",
    component: "select",
    options: [{ label: "IN", value: "IN" }],
  },
  {
    name: "type",
    label: "Type",
    component: "select",
    options: [
      { label: "Box", value: "box" },
      { label: "Case", value: "case" },
      { label: "Unit", value: "unit" },
    ],
  },
  {
    name: "depth",
    label: "Length",
    placeholder: "Length",
    component: "text",
    type: "number",
  },
  {
    name: "weightUnitOfMeasure",
    label: "Weight unit of measure",
    component: "select",
    options: [{ label: "LB", value: "LB" }],
  },
  {
    name: "height",
    label: "Height",
    placeholder: "Height",
    component: "text",
    type: "number",
  },
  {
    name: "weight",
    label: "Weight",
    placeholder: "Weight",
    component: "text",
    type: "number",
  },
  {
    name: "width",
    label: "Width",
    placeholder: "Width",
    component: "text",
    type: "number",
  },
];

export const generalSectionAccordianData = [
  { title: "Details", key: "details", content: "" },
  { title: "Taxonomy", key: "taxonomy", content: "" },
  { title: "Product Features", key: "productfeatures", content: "" },
  { title: "Attributes", key: "attributes", content: "" },
  { title: "Production Details", key: "productionDetails", content: "" },
  { title: "Ships From", key: "shipsFrom", content: "" },
  { title: "HAZMAT", key: "hazmat", content: "" },
  { title: "Logistics and customs", key: "logisticsAndCustoms", content: "" },
];

export const dimensionSectionAccordianData = [
  {
    title: "product measurement",
    key: "productMeasurement",
    content:
      "Please fill in the maximum dimensions for this product. Using a t-shirt as an example, add its dimensions when it's unfolded.",
  },
  {
    title: "product package measurement",
    key: "productPackageMeasurement",
    content:
      "Please fill in the dimensions for this product when it's packaged. Using a t-shirt as an example, add its dimensions when it's folded.",
  },
  {
    title: "shipping package measurement",
    key: "shippingPackageMeasurement",
    content:
      'Please fill in the dimensions for this product when it\'s packed and shipped within a container. Using a t-shirt as an example, 20 t-shirts are packed into container that is 18" x 14" x 12".',
  },
];

export const sizes = ["XXS", "XS", "S", "M", "L", "XL"];

export const inventoryStatuses = [
  { label: "In Stock", value: "in-stock" },
  { label: "Out of Stock", value: "out-of-stock" },
  { label: "Discontinued", value: "discontinued" },
  { label: "Low Inventory", value: "low-inventory" },
  { label: "Back Order", value: "back-order" },
  { label: "Pre Order", value: "pre-order" },
];

export const locationData: Record<string, Record<string, string[]>> = {
  US: {
    Alabama: ["Birmingham", "Montgomery", "Mobile"],
    Alaska: ["Anchorage", "Fairbanks", "Juneau"],
    Arizona: ["Phoenix", "Tucson", "Mesa"],
    Arkansas: ["Little Rock", "Fayetteville", "Fort Smith"],
    California: ["Los Angeles", "San Francisco", "San Diego", "Sacramento"],
    Colorado: ["Denver", "Colorado Springs", "Boulder"],
    Connecticut: ["Hartford", "New Haven", "Stamford"],
    Delaware: ["Wilmington", "Dover", "Newark"],
    Florida: ["Miami", "Orlando", "Tampa", "Jacksonville"],
    Georgia: ["Atlanta", "Augusta", "Savannah"],
    Hawaii: ["Honolulu", "Hilo", "Kailua"],
    Idaho: ["Boise", "Idaho Falls", "Twin Falls"],
    Illinois: ["Chicago", "Springfield", "Peoria"],
    Indiana: ["Indianapolis", "Fort Wayne", "Evansville"],
    Iowa: ["Des Moines", "Cedar Rapids", "Davenport"],
    Kansas: ["Wichita", "Overland Park", "Kansas City"],
    Kentucky: ["Louisville", "Lexington", "Bowling Green"],
    Louisiana: ["New Orleans", "Baton Rouge", "Shreveport"],
    Maine: ["Portland", "Augusta", "Bangor"],
    Maryland: ["Baltimore", "Annapolis", "Frederick"],
    Massachusetts: ["Boston", "Worcester", "Springfield"],
    Michigan: ["Detroit", "Grand Rapids", "Lansing"],
    Minnesota: ["Minneapolis", "Saint Paul", "Rochester"],
    Mississippi: ["Jackson", "Gulfport", "Hattiesburg"],
    Missouri: ["Kansas City", "St. Louis", "Springfield"],
    Montana: ["Billings", "Missoula", "Great Falls"],
    Nebraska: ["Omaha", "Lincoln", "Bellevue"],
    Nevada: ["Las Vegas", "Reno", "Henderson"],
    NewHampshire: ["Manchester", "Nashua", "Concord"],
    NewJersey: ["Newark", "Jersey City", "Paterson"],
    NewMexico: ["Albuquerque", "Santa Fe", "Las Cruces"],
    NewYork: ["New York City", "Buffalo", "Rochester"],
    NorthCarolina: ["Charlotte", "Raleigh", "Greensboro"],
    NorthDakota: ["Fargo", "Bismarck", "Grand Forks"],
    Ohio: ["Columbus", "Cleveland", "Cincinnati"],
    Oklahoma: ["Oklahoma City", "Tulsa", "Norman"],
    Oregon: ["Portland", "Salem", "Eugene"],
    Pennsylvania: ["Philadelphia", "Pittsburgh", "Harrisburg"],
    RhodeIsland: ["Providence", "Newport", "Warwick"],
    SouthCarolina: ["Charleston", "Columbia", "Greenville"],
    SouthDakota: ["Sioux Falls", "Rapid City", "Aberdeen"],
    Tennessee: ["Nashville", "Memphis", "Knoxville"],
    Texas: ["Houston", "Dallas", "Austin", "San Antonio"],
    Utah: ["Salt Lake City", "Provo", "Ogden"],
    Vermont: ["Burlington", "Montpelier", "Rutland"],
    Virginia: ["Virginia Beach", "Richmond", "Norfolk"],
    Washington: ["Seattle", "Spokane", "Tacoma"],
    WestVirginia: ["Charleston", "Huntington", "Morgantown"],
    Wisconsin: ["Milwaukee", "Madison", "Green Bay"],
    Wyoming: ["Cheyenne", "Casper", "Laramie"],
    DistrictOfColumbia: ["Washington"],
  },
  Canada: {
    Alberta: ["Calgary", "Edmonton", "Red Deer"],
    BritishColumbia: ["Vancouver", "Victoria", "Kelowna"],
    Manitoba: ["Winnipeg", "Brandon", "Steinbach"],
    NewBrunswick: ["Moncton", "Fredericton", "Saint John"],
    NewfoundlandAndLabrador: ["St. John's", "Mount Pearl", "Corner Brook"],
    NovaScotia: ["Halifax", "Sydney", "Truro"],
    Ontario: ["Toronto", "Ottawa", "Mississauga", "Hamilton"],
    PrinceEdwardIsland: ["Charlottetown", "Summerside"],
    Quebec: ["Montreal", "Quebec City", "Laval", "Gatineau"],
    Saskatchewan: ["Saskatoon", "Regina", "Prince Albert"],
    NorthwestTerritories: ["Yellowknife"],
    Nunavut: ["Iqaluit"],
    Yukon: ["Whitehorse"],
  },
};

export const productVariantColors = [
  { standardColorName: "Black", colorName: "Black", hex: "#000000" },
  { standardColorName: "Blue", colorName: "Blue", hex: "#0000FF" },
  { standardColorName: "Brown", colorName: "Brown", hex: "#A52A2A" },
  { standardColorName: "Grey", colorName: "Grey", hex: "#808080" },
  { standardColorName: "Orange", colorName: "Orange", hex: "#FFA500" },
  { standardColorName: "Purple", colorName: "Purple", hex: "#800080" },
  { standardColorName: "Red", colorName: "Red", hex: "#FF0000" },
  { standardColorName: "White", colorName: "White", hex: "#FFFFFF" },
  { standardColorName: "Yellow", colorName: "Yellow", hex: "#FFFF00" },
  { standardColorName: "Green", colorName: "Green", hex: "#008000" },
  { standardColorName: "Pink", colorName: "Pink", hex: "#FFC0CB" },
];

export const productVariantSizes = [
  { label: "XXS", value: "XXS" },
  { label: "XS", value: "XS" },
  { label: "S", value: "S" },
  { label: "M", value: "M" },
  { label: "L", value: "L" },
  { label: "XL", value: "XL" },
  { label: "2XL", value: "2XL" },
  { label: "3XL", value: "3XL" },
  { label: "4XL", value: "4XL" },
  { label: "5XL", value: "5XL" },
  { label: "6XL", value: "6XL" },
  { label: "One Size", value: "ONE SIZE" },
];

export const productPricingSizes = productVariantSizes.map(({ label }) => ({
  [label]: "",
}));

export const SIZE_ORDER: { [key: string]: number } = {
  XXS: 1,
  XS: 2,
  S: 3,
  M: 4,
  L: 5,
  XL: 6,
  "2XL": 7,
  "3XL": 8,
  "4XL": 9,
  "5XL": 10,
  "6XL": 11,
  "ONE SIZE": 12,
};

export const catalogMediaSectionAccordianData = [
  {
    title: "variants",
    catagory: "product",
    showGridView: true,
    details: [],
  },
  {
    title: "live photos",
    catagory: "lifestyle",
    showGridView: false,
    details: [{}],
  },
  {
    title: "videos",
    catagory: "video",
    showGridView: false,
    details: [{}],
  },
];

export const storageCategoryOptions = [
  {
    key: "Small item",
    value: "Small Item (Stickers, Pins, Buttons, Insert cards)",
  },
  { key: "Medium item", value: "Medium Item (Bottles, Journals, Shirts)" },
  { key: "Large item", value: "Large Item (Backpacks, Hoodies, Jackets)" },
];

export const CALCULATION_TYPE_OPTIONS = [
  { label: "Per unit", value: "per_item" },
  { label: "Per decoration", value: "per_decoration" },
  { label: "Per run", value: "per_run" },
];

export const allCategoriesData = [
  {
    name: "Clothing & Accessories",
    subCategories: [
      {
        name: "Accessories",
        subCategories2: ["Gloves & Mittens", "Headwear", "Scarves", "Socks"],
      },
      { name: "Button Downs", subCategories2: [] },
      {
        name: "Hoodies & Fleece",
        subCategories2: ["Quarter Zips", "Half Zips", "Full Zips", "Pullovers"],
      },
      {
        name: "Outerwear",
        subCategories2: [
          "3-in-1 System Jackets",
          "Insulated & Down Jackets",
          "Lightweight Jackets",
          "Softshell Jackets",
          "Vests",
        ],
      },
      { name: "Polos", subCategories2: [] },
      { name: "Pants & Shorts", subCategories2: [] },
      {
        name: "T-Shirts",
        subCategories2: [
          "Blended T-Shirts",
          "Cotton T-Shirts",
          "Performance T-Shirts",
        ],
      },
      { name: "Sweaters", subCategories2: [] },
    ],
  },
  {
    name: "Novelty",
    subCategories: [
      { name: "Games", subCategories2: [] },
      { name: "Stickers", subCategories2: [] },
      { name: "Pins", subCategories2: [] },
      { name: "Creative Gifts", subCategories2: [] },
    ],
  },
  {
    name: "Media, Awards & Services",
    subCategories: [
      { name: "Banners", subCategories2: [] },
      { name: "Awards", subCategories2: [] },
    ],
  },
  {
    name: "Drinkware",
    subCategories: [
      { name: "Drinkware Accessories", subCategories2: [] },
      { name: "Bottle Carriers", subCategories2: [] },
      { name: "Coasters", subCategories2: [] },
      { name: "Drinkware Gift Sets", subCategories2: [] },
      { name: "Glass", subCategories2: [] },
      { name: "Mugs", subCategories2: ["Ceramic Mugs", "Metal Mugs"] },
      { name: "Sport Bottles", subCategories2: [] },
      {
        name: "Tumblers",
        subCategories2: ["Tumblers With Straws", "Travel Tumblers"],
      },
      {
        name: "Vacuum Insulated",
        subCategories2: [
          "Vacuum Insulated Bottles",
          "Vacuum Insulated Mugs",
          "Vacuum Insulated Tumblers",
        ],
      },
      { name: "Water Bottle", subCategories2: [] },
    ],
  },
  {
    name: "Travel, Bags & Accessories",
    subCategories: [
      { name: "Backpacks", subCategories2: [] },
      {
        name: "Coolers",
        subCategories2: ["Backpack Coolers", "Event Coolers", "Lunch Coolers"],
      },
      { name: "Drawstring Bags", subCategories2: [] },
      { name: "Duffels", subCategories2: [] },
      { name: "Fanny Packs", subCategories2: [] },
      { name: "Luggage", subCategories2: [] },
      {
        name: "Tote Bags",
        subCategories2: [
          "Convention Totes",
          "Cotton Totes",
          "Non-Woven Totes",
          "Shopper Totes",
        ],
      },
      { name: "Travel Accessories", subCategories2: [] },
      { name: "Food Storage", subCategories2: [] },
    ],
  },
  {
    name: "Office & Journals",
    subCategories: [
      { name: "Calendars", subCategories2: [] },
      { name: "Desk Accessories", subCategories2: [] },
      {
        name: "Journals & Notebooks",
        subCategories2: [
          "Tech Integrated Journals & Notebooks",
          "Spiral Journals & Notebooks",
          "Bound Journals & Notebooks",
        ],
      },
      { name: "Lanyards & Badge Holders", subCategories2: [] },
      { name: "Office Gift Sets", subCategories2: [] },
      {
        name: "Padfolios",
        subCategories2: ["Writing Pads", "Zippered Padfolios"],
      },
      {
        name: "Writing",
        subCategories2: ["Gel Pens", "Metal Pens", "Plastic Pens", "Stylus"],
      },
    ],
  },
  {
    name: "Home, Kitchen & Dining",
    subCategories: [
      {
        name: "Blankets & Throws",
        subCategories2: ["Home Blankets", "Outdoor Blankets"],
      },
      { name: "Candles", subCategories2: [] },
      {
        name: "Housewares",
        subCategories2: [
          "Cutting Boards",
          "Wine & Cheese",
          "Food Storage",
          "Kitchen Tools",
        ],
      },
      { name: "Garden", subCategories2: [] },
      { name: "Keychains & Key Lights", subCategories2: [] },
      { name: "Food", subCategories2: ["Sweet & Savory"] },
    ],
  },
  {
    name: "Sports & Outdoor",
    subCategories: [
      { name: "Fitness Accessories", subCategories2: ["Pickleball"] },
      { name: "Flashlights & Lanterns", subCategories2: [] },
      {
        name: "Golf",
        subCategories2: [
          "Golf Accessories",
          "Golf Apparel",
          "Golf Balls",
          "Golf Towels",
        ],
      },
      {
        name: "Outdoor Living",
        subCategories2: [
          "BBQ & Picnic Sets",
          "Chairs",
          "Coolers",
          "Outdoor Games",
        ],
      },
      { name: "Sunglasses", subCategories2: [] },
      { name: "Towels & Sweatbands", subCategories2: [] },
      { name: "Umbrellas", subCategories2: [] },
    ],
  },
  { name: "Packaging & Components", subCategories: [] },
  {
    name: "Electronics & Accessories",
    subCategories: [
      { name: "Cables & Adaptors", subCategories2: [] },
      { name: "Emerging Trends", subCategories2: [] },
      {
        name: "Headphones & Earbuds",
        subCategories2: ["Earbuds", "True Wireless Earbuds", "Headphones"],
      },
      { name: "USB Flash Drives", subCategories2: [] },
      {
        name: "Powerbanks",
        subCategories2: [
          "UL Listed Power Banks",
          "Wireless Power Banks",
          "Standard Power Banks",
        ],
      },
      { name: "Speakers", subCategories2: [] },
      { name: "Tech Organizers", subCategories2: [] },
      { name: "Tech Stationery", subCategories2: [] },
      { name: "Trackers", subCategories2: [] },
      { name: "Wireless Charging", subCategories2: [] },
    ],
  },
  {
    name: "Kids & Baby",
    subCategories: [
      { name: "Toys", subCategories2: [] },
      { name: "Blankets & Throws", subCategories2: [] },
      { name: "Apparel", subCategories2: [] },
      { name: "Books", subCategories2: [] },
    ],
  },
  {
    name: "Pets",
    subCategories: [{ name: "Pet Accessories", subCategories2: [] }],
  },
  { name: "Executives", subCategories: [] },
  {
    name: "Health & Beauty",
    subCategories: [
      { name: "Hand Sanitizer", subCategories2: [] },
      { name: "Dental Hygiene", subCategories2: [] },
      { name: "First Aid Kit", subCategories2: [] },
      { name: "Health & Beauty Travel", subCategories2: [] },
      { name: "Lip Balm", subCategories2: [] },
      { name: "Lotions & Sunscreen", subCategories2: [] },
    ],
  },
];

export const getCollectionHeadCells = (
  showVendor: boolean,
  source: string = "",
) => {
  const headCells = [
    {
      id: "collectionName",
      type: "string",
      numeric: false,
      disablePadding: true,
      label: "Name",
      source,
    },
    {
      id: "status",
      type: "string",
      numeric: false,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "quantity",
      type: "string",
      numeric: false,
      disablePadding: false,
      label: "Product Quantity",
    },
    {
      id: "lastActivity",
      type: "date",
      numeric: true,
      disablePadding: false,
      label: "Last Activity",
      sortIconRight: true,
      centerAlign: true,
    },
    {
      id: "action",
      label: "",
      numeric: true,
      disablePadding: false,
    },
  ];

  return showVendor
    ? headCells
    : headCells.filter((cell) => cell.id !== "vendor");
};

export const bannerSections: BannerSection[] = [
  {
    id: "icon",
    title: "COLLECTION ICON",
    dimensions: null,
    height: 200,
    width: 200,
    device: "desktop",
    mediaCategory: "product",
    aspectRatio: "1 / 1",
  },
  {
    id: "desktop",
    title: "COLLECTION BANNER - DESKTOP VIEW",
    dimensions: "1400x265px",
    height: 200,
    width: "100%",
    device: "desktop",
    mediaCategory: "template",
    aspectRatio: "1400 / 265",
  },
  {
    id: "tablet",
    title: "COLLECTION BANNER - TABLET VIEW",
    dimensions: "942x285px",
    height: 200,
    width: "100%",
    device: "tablet",
    mediaCategory: "template",
    aspectRatio: "942 / 285",
  },
  {
    id: "mobile",
    title: "COLLECTION BANNER - MOBILE VIEW",
    dimensions: "375x285px",
    height: 200,
    width: "100%",
    device: "mobile",
    mediaCategory: "template",
    aspectRatio: "375 / 285",
  },
];

export interface CollectionStatusOption {
  label: string;
  value: string;
}

export const collectionStatus: CollectionStatusOption[] = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Published", value: "published" },
  { label: "Draft", value: "draft" },
  { label: "Pending Review", value: "pending-review" },
  { label: "In Review", value: "in-review" },
  { label: "Rejected", value: "rejected" },
  { label: "Archived", value: "archived" },
  { label: "Suspended", value: "suspended" },
  { label: "Hidden", value: "hidden" },
];

export const SALESFORCE_SYNC_TYPE_OPTIONS = [
  { label: "Catalog Product", value: "CATALOG_PRODUCT" },
  { label: "Vendor", value: "VENDOR" },
];

export const SALESFORCE_SYNC_STATUS_OPTIONS = [
  { label: "Success", value: "SUCCESS" },
  { label: "Failed", value: "FAILED" },
];

const SYNC_TYPE_LABELS: Record<string, string> = {
  SOURCE_PRODUCT: "Source Product",
  CATALOG_PRODUCT: "Catalog Product",
  VENDOR: "Vendor",
};

export const salesforceSyncLogHeadCells: any = [
  {
    id: "syncedAt",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Sync Date",
    width: 200,
  },
  {
    id: "syncType",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Sync Type",
    width: 140,
  },
  {
    id: "adminItemId",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Admin Item ID",
    width: 160,
  },
  {
    id: "itemName",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Item Name",
    width: 180,
  },
  {
    id: "productCode",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Product Code",
    width: 140,
  },
  {
    id: "status",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Status",
    width: 110,
  },
  {
    id: "errorMessage",
    type: "string",
    numeric: false,
    disablePadding: false,
    label: "Error Message",
    width: 240,
    wrapText: true,
  },
];

function formatSyncProductCode(item: any): string {
  if (item.syncType === "VENDOR") {
    const parts = [item.bdaSupplierNumber, item.supplierSiteId].filter(Boolean);
    if (parts.length) return parts.join(" / ");
  }
  if (item.syncType === "SOURCE_PRODUCT") {
    return item.vendorProductCode || item.productCode || "";
  }
  return (
    item.catalogProductCode ||
    item.productCode ||
    item.vendorProductCode ||
    ""
  );
}

export const transformSalesforceSyncLogs = (data: any) => {
  const items = data?.salesforceSyncLogs?.items || [];

  return items.map((item: any) => {
    const syncedAt = item.syncedAt ? new Date(item.syncedAt) : null;
    return createData({
      id: item.id,
      syncedAt: syncedAt
        ? syncedAt.toLocaleString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          })
        : "",
      syncType: SYNC_TYPE_LABELS[item.syncType] || item.syncType || "",
      adminItemId: item.adminItemId || "",
      itemName: item.itemName || "",
      productCode: formatSyncProductCode(item),
      status: item.status === "SUCCESS" ? "Success" : "Failed",
      errorMessage:
        item.status === "FAILED" ? item.errorMessage || "" : "",
    });
  });
};
